import {Form,Formik,Field} from 'formik'
import Input from '../Input/Input';
import { validationSchema } from './validations';







const FormBuy = ({onClick, submitBtnText}) =>{
return(
    <>
    <Formik
    
    initialValues={{
        name: '', 
        lastName: '',
        age: '',
        address:'',
        phoneNumber:'',
        email: ''  
    }}
    onSubmit={(values)=>{console.log('submit',values)}}
    validationSchema = {validationSchema}
    >
      {({
         values,
         errors,
         touched,
         handleChange,
         handleBlur,
         handleSubmit,
         isSubmitting,
         
       }) => (
         <Form>
            <div>
                <Input className='input' label='Your name:' typeInput='text' name='name' placeholder='Name' error={errors.name}/>
                <Input className='input' label='Your last name:' typeInput='text' name='lastName' placeholder='Last name' error={errors.lastName}/>
                <Input className='input' label='Your age:' typeInput='text' name='age' placeholder='Age' error={errors.age} />
                <Input className='input' label='Address for delivery:' typeInput='text' name='address' error={errors.address} placeholder='Address'/>
                <Input className='input' label='Your phone number:' typeInput='text' name='phoneNumber' error={errors.phoneNumber} placeholder='+38 (xxx) xx xx xxx'/>
                <Input className='input' label='Your email:' typeInput='email' name='email' error={errors.email} placeholder='your@gmail.com'/>
            </div>
            
            <button className='btn-submit' type='submit' onClick={isSubmitting && onClick}>{submitBtnText}</button>
            
         </Form>
       )}
   



    </Formik>
 
    </>
)

}

export default FormBuy;

